<div class="l-align-items-center">
  <img class="icon-urgency" [src]="getUrgencyIcon()" />
  <!-- <span class="t-space--med"></span>
  <span *ngIf="labUserSw">{{ order.urgencyLabDescr }}</span>
  <span *ngIf="plantUserSw">{{ order.urgencyPlantDescr }}</span> -->
</div>
